import PropTypes from "prop-types";

import { Button } from "@/components/ui/button";
import ACL_RELATIONSHIPS from "acl-relationships";
import withRoleCheck from "components/hocs/withRoleCheck";
import { NewNoteModal as _NewNoteModal } from "components/modals/NoteModals";

const NewNoteModal = withRoleCheck(_NewNoteModal, [
  ACL_RELATIONSHIPS.activity.create,
]);

/** Opens the new-note form with the note pointing back at this entry. */
const CreateNoteButton = ({
  modelType,
  modelId,
  logId,
  label = "Create Note from Activity",
}) => (
  <NewNoteModal
    modelType={modelType}
    modelId={modelId}
    refersToModel="AuditLog"
    refersToID={logId}
    trigger={
      <Button variant="outline" size="sm">
        {label}
      </Button>
    }
  />
);

CreateNoteButton.propTypes = {
  modelType: PropTypes.string,
  modelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  logId: PropTypes.number,
  label: PropTypes.string,
};

export default CreateNoteButton;
